module.exports = __webpack_public_path__ + "static/media/Wolf_skewer.cefa3391.png";